import BaseProxy from "../../base-proxy";

//#region Private Methods
let parseInput = (input) => {
  return {
    authToken: input.authToken,
    user: {
      first_name: input.user.firstName ? input.user.firstName : input.user.first_name,
      last_name: input.user.lastName ? input.user.lastName : input.user.last_name,
      middle_name: input.user.middleName ? input.user.middleName : input.user.middle_name,
      email: input.user.email,
      phone: input.user.phone,
      ...(input.user.government_registrations ? { government_registrations: input.user.government_registrations } : {}),
      ...(input.user.address ? { address: input.user.address } : {}),
    },
    director: input.director,
    shareholder: input.shareholder,
    is_main_point_of_contact: input.isPointOfContact,
    invitation_status: input.invitationStatus,
    ...(input.partner && { partner: input.partner }),
  };
};

//#endregion

/**
 * @class InsertCompanyUserProxy
 * @description Class used for communicating with company API.
 * @author Mathieu R.
 * @version 1.0
 * @since November 29, 2018
 */
export default class InsertCompanyUserProxy {
  /**
   * @async
   * @function execute
   * @param input - Input parameter instance.
   * @param {String} input.authToken - Token used for issuing authenticated request.
   * @param {String} input.companyId - Id of companyUser's company.
   * @param {String} input.user.firstName - FirstName of companyUser's user.
   * @param {String} input.user.lastName - LastName of companyUser's user.
   * @param {String} input.user.email - Email of companyUser's user.
   * @param {Object} input.director - Director object.
   * @param {Object} input.shareholder - Shareholder object.
   * @param {Object} input.isPointOfContact - CompanyUser main point of contact.
   * @param {Object} input.invitationStatus - InvitationStatus object.
   * @param {Object} input.partner - Partner Id of partner user.
   */
  async execute(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/companies/${input.companyId}/company-users`;
    input = parseInput(input);

    return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, input);
  }
}
